import { Action } from '@/models/action.model';
import { Hero } from '@/models/hero.model';
import { InfoItem } from '@/models/info-item.model';
import { InfoGraphic } from '@/models/info-graphic.model';
import { QuizQuestion } from '@/models/quiz-question.model';
import { Story } from '@/models/story.model';
import { TranslationState } from '@/models/translation.model';
import { Initiative } from '@/models/initiative.model';

export enum DisplayType {
  Normal = 'normal',
}

export interface StoryItem {
  id: number;
  story: Story;
  parentItem: StoryItem | null;
  column: number;
  row: number;
  displayType: DisplayType;
  infoGraphic?: InfoGraphic;
  info?: InfoItem;
  question?: QuizQuestion;
  hero?: Hero;
  actions: Action[];
  initiatives: Initiative[];
  translated?: TranslationState;
}

export const categoryRules = [
  (value: string) => {
    if (value) return true;

    return 'Category is required.';
  },
];
